<script lang="ts">
    import JobHistory from './JobHistory.svelte';

    export let componentProps: any;
</script>

<JobHistory {...componentProps} />
